import { Col, Row } from 'antd';
import AiPerformanceCard from '../ai-performace-card/ai-performance-card';
import styles from './ai-performance-cards-wrapper.module.scss';
import { AiPerformance } from '@/services/dashboard-service/dashboard.service.types';
import { AiPerformanceCardTitles } from '@/constants/ai-performance.constants';
import { tooltips } from './ai-performance-cards.utils';

interface AiPerformanceCardsWrapperProps {
  aiPerformanceData?: AiPerformance;
  aiPerformanceChart?: AiPerformance['chart'];
  isLoading: boolean;
}

export default function AiPerformanceCardsWrapper({
  aiPerformanceData,
  aiPerformanceChart,
  isLoading,
}: AiPerformanceCardsWrapperProps) {
  const getArrowColor = (change?: number, title?: string, oppositeDirection?: boolean): string => {
    if (change === undefined) return '';

    if (
      title === AiPerformanceCardTitles.RESPONSES_PER_CALL ||
      title === AiPerformanceCardTitles.AI_HANDLING_TIME
    ) {
      return styles.neutral;
    }

    const isPositive = change > 0;

    if (oppositeDirection) {
      return isPositive ? styles.decrease : styles.increase;
    }

    return isPositive ? styles.increase : styles.decrease;
  };

  return (
    <>
      <Row className={styles.aiPerformanceCardsWrapperRow}>
        <Col className={styles.aiPerformanceCardsWrapperCol}>
          <AiPerformanceCard
            tooltip={tooltips.averageResponses}
            title={AiPerformanceCardTitles.RESPONSES_PER_CALL}
            isLoading={isLoading}
            aiPerformanceData={aiPerformanceData?.number_of_responses}
            aiPerformanceChart={aiPerformanceChart?.number_of_responses}
            arrowColor={getArrowColor(
              aiPerformanceData?.number_of_responses?.change,
              AiPerformanceCardTitles.RESPONSES_PER_CALL
            )}
          />
        </Col>
        <Col className={styles.aiPerformanceCardsWrapperCol}>
          <AiPerformanceCard
            tooltip={tooltips.handlingTime}
            title={AiPerformanceCardTitles.AI_HANDLING_TIME}
            isLoading={isLoading}
            aiPerformanceData={aiPerformanceData?.average_ai_handling_time}
            aiPerformanceChart={aiPerformanceChart?.average_ai_handling_time}
            arrowColor={getArrowColor(
              aiPerformanceData?.average_ai_handling_time?.change,
              AiPerformanceCardTitles.AI_HANDLING_TIME,
              true
            )}
          />
        </Col>
        <Col className={styles.aiPerformanceCardsWrapperCol}>
          <AiPerformanceCard
            tooltip={tooltips.responseTime}
            title={AiPerformanceCardTitles.RESPONSE_TIME}
            isLoading={isLoading}
            aiPerformanceData={aiPerformanceData?.average_response_time}
            aiPerformanceChart={aiPerformanceChart?.average_response_time_chart}
            arrowColor={getArrowColor(
              aiPerformanceData?.average_response_time?.change,
              AiPerformanceCardTitles.RESPONSE_TIME,
              true
            )}
          />
        </Col>
      </Row>
    </>
  );
}
